import IOrderService from "@/services/IOrderService";
import OrderCreate from "@/models/order/OrderCreate";
import CreateResponse from "@/models/CreateResponse";
import Vue from "vue";
import Order from "@/models/order/Order";
import OrderListFilter from "@/models/order/OrderListFilter";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import OrderListEntry from "@/models/order/OrderListEntry";
import PaginatedResponse from "@/models/PaginatedResponse";
import PlanningEntryCreate from "@/models/planningEntry/PlanningEntryCreate";
import OrderUpdate from "@/models/order/OrderUpdate";
import ReportListFilter from "@/models/report/ReportListFilter";
import ReportListEntry from "@/models/report/ReportListEntry";
import PlanningEntryListFilter from "@/models/planningEntry/PlanningEntryListFilter";
import PlanningEntryListEntry from "@/models/planningEntry/PlanningEntryListEntry";

export default class AxiosOrderService implements IOrderService {

	public order(id: string): Promise<Order> {
		return Vue.$axios.get<Order>(`/order/${id}`).then(res => res.data);
	}

	public orders(filter: OrderListFilter | null, options: AsiListTableOptions | null): Promise<PaginatedResponse<OrderListEntry>> {
		return Vue.$axios.get<PaginatedResponse<OrderListEntry>>('/order', {
			params: {
				...filter,
				...options
			}
		})
			.then(res => res.data);
	}

	public create(model: OrderCreate): Promise<CreateResponse> {
		return Vue.$axios.post<CreateResponse>(`/company/${model.companyId}/order`, model).then(res => res.data);
	}

	public delete(id: string): Promise<null> {
		return Vue.$axios.delete(`/order/${id}`).then(res => res.data);
	}

	public update(id: string, model: OrderUpdate): Promise<null> {
		return Vue.$axios.patch(`/order/${id}`, model).then(res => res.data);
	}

	public createPlanningEntry(id: string, model: PlanningEntryCreate): Promise<CreateResponse> {
		return Vue.$axios.post<CreateResponse>(`/order/${id}/planning-entry`, model).then(res => res.data);
	}

	public planningEntries(id: string, filter: PlanningEntryListFilter | null, options: AsiListTableOptions | null): Promise<PaginatedResponse<PlanningEntryListEntry>> {
		return Vue.$axios.get<PaginatedResponse<PlanningEntryListEntry>>(`/order/${id}/planning-entry`, {
			params: {
				...filter,
				...options
			}
		})
			.then(res => res.data);
	}

	public reports(id: string, filter: ReportListFilter | null, options: AsiListTableOptions | null): Promise<PaginatedResponse<ReportListEntry>> {
		return Vue.$axios.get<PaginatedResponse<ReportListEntry>>(`/order/${id}/report`, {
			params: {
				...filter,
				...options
			}
		})
			.then(res => res.data);
	}

}
